import {
  ProviderEmailAddress,
  DriverEmailAddress,
} from '../data/models/email-address.model';

export enum ProviderEmailUse {
  Dispatch = 1,
  Billing = 2,
  Owner = 3,
}

export enum DriverEmailUse {
  Primary = 1,
}

class EmailUtils {
  public getProviderEmail(
    emails: ProviderEmailAddress[] | undefined,
    use: ProviderEmailUse,
  ): ProviderEmailAddress | undefined {
    return (emails || []).find(
      (num) => num.transportationProviderEmailUseID === use,
    );
  }

  public getDriverEmail(
    emails: DriverEmailAddress[] | undefined,
    use: DriverEmailUse = DriverEmailUse.Primary,
  ): any {
    return (emails || []).find((num) => num.driverEmailUseID === use);
  }
}

const emailUtils = new EmailUtils();

export default emailUtils;
